<div class="input-wrapper">
    @if (!inputOnly) {
        @if (formInputData?.label || forceShowLabel) {
            <div
                class="input-wrapper__label d-flex align-items-baseline"
                [ngClass]="{
                    'w-50 compensate-padding-right': labelIsHalfWidth,
                }"
            >
                @if (formInputData?.isLocked) {
                    <wdx-icon
                        class="text-muted me-2"
                        icon="lock"
                        iconStyle="fas"
                    ></wdx-icon>
                }
                @if (formInputData?.guidanceText) {
                    <atom-guidance-text-icon
                        class="d-block me-2"
                        [guidanceText]="formInputData.guidanceText"
                    ></atom-guidance-text-icon>
                }
                <div class="form-label d-flex flex-grow-1 flex-lg-grow-0 me-1">
                    {{ formInputData.label | translateTokenisedString }}
                    @if (formInputData.isRequired) {
                        <sup class="ms-1 me-4">
                            <wdx-icon
                                class="text-danger"
                                icon="asterisk"
                            ></wdx-icon>
                        </sup>
                    }
                </div>
                @if (formDisplayMode !== FORM_DISPLAY_MODE.Summary) {
                    <ng-content select=".action-buttons"></ng-content>
                }
            </div>
        }
    }
    <div
        class="input-wrapper__content"
        [class.ml-0]="!formInputData?.label || hideGuidanceText"
        [attr.data-cy]="'card-' + formInputData?.label"
    >
        <ng-content></ng-content>

        @if (!inputOnly) {
            <div class="invalid-feedback">
                {{ validationErrorMessage || '&nbsp;' }}
            </div>
        }
    </div>
</div>
